import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ProgressCircle } from '@sm/wds-react';

const PageLoading = props => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true);
    }, props.delay);
    return () => clearTimeout(timer);
  }, [props.delay]);
  return (
    <div className="coreweb-page-loading">
      <Choose>
        <When condition={loading}>
          <div className="wds-flex wds-flex--x-center wds-m-t-5">
            <ProgressCircle continuous />
          </div>
        </When>
      </Choose>
    </div>
  );
};

PageLoading.propTypes = {
  delay: PropTypes.number,
};

PageLoading.defaultProps = {
  delay: 200,
};

export default PageLoading;
